import { buildHeaders } from "@bkry/bowline-utils";
import { select } from "redux-saga/effects";

// TODO: Change name (now it gets cache or fetches request)
export function* getCachedPayload(
  resourceName,
  actionType,
  apiRequest,
  successActions,
  failActions,
  cacheDuration = 10000
) {
  const { lastPayload, lastTimestamp } = yield getCache(
    resourceName,
    actionType
  );

  let headers = yield buildHeaders();
  const isCreator = !!headers["creator-token"];

  const isCacheValid =
    !isCreator && lastTimestamp && Date.now() - lastTimestamp < cacheDuration;

  if (isCacheValid) {
    yield* successActions(lastPayload);
    return;
  }

  try {
    const newPayload = yield apiRequest();

    yield* successActions(newPayload);
  } catch (error) {
    yield failActions(error);
  }
}

function* getCache(resourceName, actionType) {
  let dictionary;
  let payloadToString;

  if (actionType === "list") {
    dictionary = yield select(
      (state) => state[resourceName]?.filtersDictionary
    );

    payloadToString = yield select(
      (state) => state[resourceName]?.payloadToString
    );
  } else if (actionType === "show") {
    dictionary = yield select(
      (state) => state[resourceName]?.cachedShowDictionary
    );

    payloadToString = yield select(
      (state) => state[resourceName]?.showPayloadToString
    );
  }

  return {
    lastPayload: dictionary?.[payloadToString]?.payload || null,
    lastTimestamp: dictionary?.[payloadToString]?.timestamp || null,
  };
}
